// extracted by mini-css-extract-plugin
module.exports = {"dimmer":"_-ui-admin-lib-Dimmer-index-module__dimmer--2bs7Z"};